export const userViewRecommendedPlanPage = email => ({
  type: 'User views Recommended Plan page',
  data: {
    customer_info: {
      email: email,
    },
  },
});

export const userContinuesFromRecommendedPlan = (
  email,
  selectedRecipes,
  selectedExtras = [],
) => {
  const dryRecipeCount = selectedRecipes?.dry?.length || 0;
  const freshRecipeCount = selectedRecipes?.fresh?.length || 0;
  return {
    type: 'User continues from recommended plan',
    data: {
      customer_info: {
        email: email,
      },
      recipes_count: dryRecipeCount + freshRecipeCount,
      recipes_selected: selectedRecipes,
      ...(selectedExtras.length > 0
        ? {
            extras_count: selectedExtras.length,
            extras_selected: selectedExtras,
          }
        : {}),
    },
  };
};

export const userClickCreateOwnPlan = email => ({
  type: 'User clicks creates own plan',
  data: {
    customer_info: {
      email: email,
    },
  },
});

export const recipeSelected = recipe => ({
  type: 'Recipe Selected',
  data: {
    recipe,
  },
});

export const recipeUnselected = recipe => ({
  type: 'Recipe Unselected',
  data: {
    recipe,
  },
});

export const userExpandsFreshRecipeDetails = recipe => ({
  type: 'User expands fresh recipe details',
  data: {
    recipe,
  },
});
